import i18n from "@/i18n";
import { DailyStrings } from "./translations";

// A line of Daily Service text in the player's language. The language is
// set once, from the browser, before anything is drawn (see src/i18n.ts).
//
// Values are put in as they are: React makes text safe when it draws it, so
// escaping here as well would show a city like "Tokyo / Narita" as
// "Tokyo &#x2F; Narita".
export const dt = (key: keyof DailyStrings, values?: Record<string, string | number>): string =>
  i18n.t(`daily.${key}`, { ...values, interpolation: { escapeValue: false } }) as string;

// The player's language as a two-letter code, e.g. "de".
export const language = (): string => (i18n.resolvedLanguage ?? i18n.language ?? "en").slice(0, 2);

// The player's full locale, for formatting numbers and dates.
export const locale = (): string => i18n.language || "en";
